import get from 'lodash/get';
import map from 'lodash/map';
import pickBy from 'lodash/pickBy';
import filter from 'lodash/filter';
import property from 'lodash/property';

import { createSelector } from 'reselect';

import getParent from '../../selectors';

const getNames = parameters => map(parameters, property('name'));

export const getSelectedParameters = state => getParent(state).dataset.parameters;

export const getSelectedParametersNames = state => getNames(getSelectedParameters(state));

export const getVisibleSelectedParameters = createSelector(getSelectedParameters,
  selectedParameters => pickBy(selectedParameters, property('isVisible'))
);

export const getVisibleSelectedParametersNames = state => getNames(getVisibleSelectedParameters(state));

const getVisibleSelectedParametersNamesByType = type => createSelector(
  getVisibleSelectedParameters,

  visibleSelectedParameters => {
    const parameters = filter(
      visibleSelectedParameters,
      { targetType: type }
    );

    return getNames(parameters);
  }
);

export const getVisibleNumericalSelectedParametersNames = getVisibleSelectedParametersNamesByType('numerical');
export const getVisibleCategoricalSelectedParametersNames = getVisibleSelectedParametersNamesByType('categorical');

export const getSelectedParameterByName = (state, name) => get(getSelectedParameters(state), name);

export const getSelectedParameterType = (state, name) => get(getSelectedParameterByName(state, name), 'targetType');

export const isCategoricalSelectedParameterType = (state, name) => getSelectedParameterType(state, name) === 'categorical';
export const isVisibleNumericalSelectedParameters = state => !!getVisibleNumericalSelectedParametersNames(state).length;

export const areParametersSelected = state => !!getSelectedParameters(state);

export default getSelectedParameters;
